import { BaseModel } from './base';

export class TendrStatus extends BaseModel {
  statusName: string;
  id: string;
  _id: string;
}
